export default {"src":"/_next/static/media/content_pdf.cb7802f5.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};